import excelToJson from '/utils/convert-excel-to-json.js'
import _ from 'lodash'
import getLeafNodes from '/utils/get-leaf-nodes'

const parseUploadedData = ({ base64Data, file, instance_data }) => {

  try {
    const filetype = file.name.split(".").pop()

    let content

    switch (filetype) {
      case "xlsx": {
        const leafNodes = getLeafNodes(instance_data)

        let emptyInstanceData = {}
        leafNodes.map(n => _.set(emptyInstanceData, n, null))

        const buffer = Buffer.from(base64Data, "base64")
        const ed = excelToJson({ source: buffer, type: "buffer" })
        const sheets = Object.keys(ed)
        const structuredData = ed[sheets[0]]

        let sheetrows = []

        let type = "header"

        structuredData.map(i => {
          if (i.A === '-- -- -- -- --') {
            type = "body"
          } else {
            if (type === "body") {
              const keys = Object.keys(i)
              let allValues = ""

              for (let k in keys) allValues += i[keys[k]]

              if (allValues.length) sheetrows.push(i)
            }
          }
        })


        content = sheetrows.map(row => {
          let item = _.cloneDeep(emptyInstanceData)

          for (let letter in row) {
            _.set(item, leafNodes[letterToLeafNodeIndex(letter)], row[letter])
          }
          return item
        })

        break
      }

      case "csv": {
        const data = atob(base64Data)

        const leafNodes = getLeafNodes(instance_data)

        content = []

        const rows = data.split("\n")
        let header = rows.shift()
        header = header.split(",")

        rows.map(r => {
          const row = r.split(",")

          let data_item = {}

          row.map((item, idx) => {
            _.set(data_item, leafNodes[idx], item)
          })
          content.push(data_item)
        })

        break
      }

      case "json": {
        const data = atob(base64Data)
        content = JSON.parse(data)
        break
      }
    }

    // We need an array. Make one here if user uploaded a single pass JSON object
    if (!Array.isArray(content)) content = [content]

    return content
  }
  catch (err) {
    console.log(err)
  }
}

export default parseUploadedData

const letterToLeafNodeIndex = letters => {
  const splitLetters = letters.split("")
  let index = 0

  splitLetters.map(l => index += l.charCodeAt(0) - 64)

  return index - 1

}